import { render, staticRenderFns } from "./AssetsSelectModel.vue?vue&type=template&id=2eedfd03&scoped=true"
import script from "./AssetsSelectModel.vue?vue&type=script&lang=js"
export * from "./AssetsSelectModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eedfd03",
  null
  
)

export default component.exports